import axios from "axios"

export interface Config {
  openIdAuthority: string
  openIdClientId: string
  openIdProfileUrl: string
  openIdPictureUrl: string
  apis: any
  reportSystemName: string
  remoteApps: string
  timeout: number
  baseLanguage: string
  apiScope: string
  languages: any[]
}

export default class ConfigService {
  public static Current: Config

  public static async load() {
    const response = await axios.get("/config.json")
    ConfigService.Current = response.data as Config
  }
}
